import React from 'react'
import Scroll from '../../pages/Scroll/Scroll'
import Footer from '../../pages/Footer/Footer'
import LocalImage from './LocalImage'
import LocalText from './LocalText'
import LocalCard from './LocalCard'

const Local = () => {
  return (
    <>
    <LocalImage/>
    <LocalText/>
    <LocalCard/>
    <Scroll/>
    <Footer/>
      
    </>
  )
}

export default Local
